import { datadogRum } from '@datadog/browser-rum';
import IsCarvanaMobileAppUserAgent from './isCarvanaMobileApp';

const VALID_EXPERIMENT_ENVIRONMENTS = ['development', 'test', 'production'];

export const resolveExperimentEnvironment = (environment?: string | null): string => {
  if (environment && VALID_EXPERIMENT_ENVIRONMENTS.includes(environment)) return environment;
  const nodeEnv = process.env.NODE_ENV;
  return nodeEnv && VALID_EXPERIMENT_ENVIRONMENTS.includes(nodeEnv) ? nodeEnv : 'production';
};

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export type ExperimentIdentifierShape = 'carvanaUserId' | 'missing' | 'malformed';

export const classifyExperimentIdentifier = (identifier?: string | null): ExperimentIdentifierShape => {
  if (!identifier) return 'missing';
  return GUID_PATTERN.test(identifier) ? 'carvanaUserId' : 'malformed';
};

export interface ExperimentResolution {
  experiment: string;
  environment?: string;
  identifier?: string | null;
  bucket?: string;
}

export const logExperimentResolution = ({
  experiment,
  environment,
  identifier,
  bucket,
}: ExperimentResolution): void => {
  try {
    const envValid = !!environment && VALID_EXPERIMENT_ENVIRONMENTS.includes(environment);
    const identifierShape = classifyExperimentIdentifier(identifier);
    const isTreatment = !!bucket?.includes('treatment');
    const fellBackToControl = !envValid || identifierShape !== 'carvanaUserId';
    const surface = IsCarvanaMobileAppUserAgent() ? 'carvana-native-webview' : 'web';

    const context = {
      experiment,
      environment: environment ?? null,
      envValid,
      identifierShape,
      surface,
      bucket: bucket ?? null,
      isTreatment,
      fellBackToControl,
    };

    datadogRum.addAction('experiment-bucket-resolved', context);

    if (fellBackToControl) {
      datadogRum.addError(
        new Error(
          `experiment-bucket-fallback: ${experiment} could not honor its ramp ` +
            `(envValid=${envValid}, identifier=${identifierShape})`
        ),
        context
      );
    }
  } catch {
    return;
  }
};
